var _path, _path2, _path3, _path4, _path5, _path6, _g, _rect, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveyBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 96,
    viewBox: "0 0 120 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6914 35.0427C44.6914 35.0427 39.3471 37.0558 36.1374 41.6155C32.8143 46.3364 38.2572 61.7368 38.2572 61.7368L44.6914 35.0427Z",
    fill: "#E4E1FF",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5832 32.3862C75.4631 32.6936 76.6505 36.1498 76.6505 36.1498C76.6505 36.1498 78.0618 35.5607 79.482 36.1474C80.9022 36.734 82.3219 38.0976 82.3198 40.3723C82.3177 42.647 81.5035 45.8322 79.4663 53.1129C77.4292 60.3935 66.6374 77.1239 66.6374 77.1239C66.6374 77.1239 40.0437 73.137 36.9998 70.0005C37.411 50.9244 42.0887 40.5232 45.385 33.5796C48.6812 26.6361 54.705 9.93972 56.0501 7.48466C57.3952 5.0296 59.2909 3.80542 61.7409 4.3851C64.1909 4.96477 64.4464 7.54827 63.9754 9.93123C60.3784 28.1313 69.3561 31.695 73.5832 32.3862Z",
    fill: "#E4E1FF",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0117 33.2454L72.42 10.8496C72.6389 8.81439 71.2458 7.01438 69.2147 6.70784C67.1101 6.3902 65.0624 7.78415 64.5826 9.8611L59.5461 31.6659L70.0117 33.2454Z",
    fill: "#E4E1FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3871 32.8098L72.5732 12.0667C72.9093 9.87843 71.4417 7.887 69.2489 7.55606V7.55606C67.0785 7.2285 64.9604 8.64403 64.4274 10.7783L57.813 37.2624",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3463 40.5524L77.269 29.0492C77.415 27.2286 76.1495 25.6141 74.3446 25.3183V25.3183C72.4095 25.0013 70.5609 26.3084 70.2149 28.2386L68.2251 39.3381",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0002 66.9995H74.0002V75.9995H37.0002V66.9995Z",
    fill: "white",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5406_10744)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.9998,
    y: 3.99951,
    width: 62,
    height: 30,
    fill: "#FFBB00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 18.999,
    r: 9,
    fill: "white",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.5459,
    cy: 5.20996,
    r: 5.5,
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.4995,
    cy: 6.49902,
    r: 5.5,
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4575,
    cy: 32.21,
    r: 5.5,
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.4995,
    cy: 31.5,
    r: 5.5,
    fill: "#1B1B1B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.7498,
    y: 4.74951,
    width: 60.5,
    height: 28.5,
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2312 41.9484L63.9715 8.82722C64.4043 6.70024 63.1114 4.6324 61.0086 4.08861C58.9185 3.5481 56.7311 4.69574 55.9816 6.72597L45.2538 35.788L57.2312 41.9484Z",
    fill: "#E4E1FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4344 37.29L63.9968 8.86038C64.4192 6.70142 63.0987 4.61369 60.9657 4.06806V4.06806C58.8842 3.53562 56.7035 4.64664 55.9033 6.64728L44.7793 34.4571",
    stroke: "#1B1B1B",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33 72.9995V91.9995L78 91.9995V72.9995L33 72.9995Z",
    fill: "#8372FF",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5406_10744"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.9998,
    y: 3.99951,
    width: 62,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyBusiness);
export default __webpack_public_path__ + "static/media/survey-business.48ac32aa.svg";
export { ForwardRef as ReactComponent };